import { render, staticRenderFns } from "./EmployeeRecognitionDelete.vue?vue&type=template&id=8b1844c4"
import script from "./EmployeeRecognitionDelete.vue?vue&type=script&lang=js"
export * from "./EmployeeRecognitionDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports